import { useEffect, useLayoutEffect, useReducer, useState } from "react"
import { lockedReducer } from "../../utils/defaultReducer"
import { Box, Paper } from "@mui/material"
import Shadow from "../../utils/shadowDom";
import { fieldTypes, FieldObject } from "./renders";

// Ainda vamos poder fazer configurações gerais sobre o formulário (cor de fundo, cor de texto, tamanho de fonte).
// Configurações gerais sobre os objetos (posição, tamanho, fonte, required, negrito, italico, cor de texto, cor de fundo)
// O botão para enviar o formulário sempre aparecerá em baixo. 
// Será possível modificar os atributos do botão dele igual um fieldObject, mas ele não será permutavel igual os outros itens

export const fieldObject = ({ state, title, type, position, required = false, category, props = {}, contact_custom_field_id = null, contact_enterprise_custom_field_id = null, journey_custom_field_id = null }) => {
    return ({
        state: state,
        title: title,
        type: type,
        position: position,
        props: props,
        required: required,
        category: category,
        contact_custom_field_id: contact_custom_field_id,
        contact_enterprise_custom_field_id: contact_enterprise_custom_field_id,
        journey_custom_field_id: journey_custom_field_id
    })
}

const categories = {
    misc               : { name : 'Geral' },
    contact            : { name : 'Contato' },
    contact_enterprise : { name : 'Empresa' },
    opportunity        : { name : 'Oportunidade' }
}

export const possibleFields = {
    // misc 
    logo: fieldObject({ state: 'selection', title: 'Logo', type: 'logo', position: 0, category: 'misc' }),
    title: fieldObject({ state: 'selection', title: 'Título', type: 'label', position: 0, category: 'misc' }),
    description: fieldObject({ state: 'selection', title: 'Descrição', type: 'description', position: 0, category: 'misc' }),

    // contact
    contact_name: fieldObject({ state: 'selection', title: 'Nome', type: 'text', position: 0, required: true, category: 'contact', props: {required: true} }),
    contact_email: fieldObject({ state: 'selection', title: 'Email', type: 'email', position: 0, required: true, category: 'contact' , props: {required: true}}),
    contact_telephone: fieldObject({ state: 'selection', title: 'Telefone', type: 'telephone', position: 0, required: true, category: 'contact', props: {required: true} }),
    contact_cpf: fieldObject({ state: 'selection', title: 'CPF', type: 'cpf', position: 0, category: 'contact' }),
    contact_birthday: fieldObject({ state: 'selection', title: 'Aniversário', type: 'date', position: 0, category: 'contact' }),

    //enterprise
    contact_enterprise_name: fieldObject({ state: 'selection', title: 'Empresa', type: 'text', position: 0, category: 'contact_enterprise' }),
    contact_enterprise_email: fieldObject({ state: 'selection', title: 'E-mail Corporativo', type: 'email', position: 0, category: 'contact_enterprise' }),
    contact_enterprise_telephone: fieldObject({ state: 'selection', title: 'Telefone Corporativo', type: 'telephone', position: 0, category: 'contact_enterprise' }),
    contact_enterprise_cnpj: fieldObject({ state: 'selection', title: 'CNPJ', type: 'cnpj', position: 0, category: 'contact_enterprise' }),
    // + address?
    opportunity_description: fieldObject({ state: 'selection', title: 'Descrição da oportunidade', type: 'textarea', position: 0, category: 'opportunity' }),
    opportunity_attachments: fieldObject({ state: 'selection', title: 'Anexo', type: 'file', position: 0, category: 'opportunity' }),
}
    
const initialFields = ['logo', 'title', 'contact_name', 'contact_email', 'contact_telephone']

export const initialState = {
    form: possibleFields
}

const typeMap = {
    string  : "text",
    integer : "number"
}

export const mapCustomFields = (category, fields = []) => {
    return fields.reduce((acc, field, index) => {
        acc[`${category}_custom_${field.id}`] = fieldObject({
            state: "selection",
            title: field.field_name || field.name,
            type: "custom",
            position: 0,
            category: category,
            contact_custom_field_id: category === "contact" ? field.id : null,
            contact_enterprise_custom_field_id: category === "contact_enterprise" ? field.id : null,
            journey_custom_field_id: category === "opportunity" ? field.id : null,
        })

        return acc
    }, {})
}

const init = (initial, contactCustomFields, contactEnterpriseCustomFields, journeyCustomFields) => {
    return {
        ...initial,
        form: {
            ...possibleFields,
            ...mapCustomFields("contact", contactCustomFields),
            ...mapCustomFields("contact_enterprise", contactEnterpriseCustomFields),
            ...mapCustomFields("opportunity", journeyCustomFields),
        }
    }
}

const WebFormsStep2 = ({ parent, setParent, contactCustomFields, contactEnterpriseCustomFields, journeyCustomFields }) => {

    const [state, setState] = useReducer(
        lockedReducer,
        initialState,
        (initArgs) => init(initArgs, contactCustomFields, contactEnterpriseCustomFields, journeyCustomFields)
    )

    const [dragSource, setDragSource] = useState(null);
    const [dragItem, setDragItem] = useState(null);
    const [droppedInsideForm, setDroppedInsideForm] = useState(false);
    const [isDraggingOverForm, setIsDraggingOverForm] = useState(false);
    const [placeholderIndex, setPlaceholderIndex] = useState(null);
    const [shadowRoot, setShadowRoot] = useState(null);

    const formItems = Object.entries(state.form).flatMap(([key, values]) => {
        if (values.state !== 'form') return []
        return [{ id: key, ...values }]
    }).toSorted((a, b) => a.position - b.position)

    const selectionItems = Object.entries(state.form).flatMap(([key, values]) => {
        if (values.state !== 'selection') return []
        return [{ id: key, ...values }]
    })

    useLayoutEffect(() => {
        if (Object.keys(parent.form || {}).length === 0 && parent.id === 0) {
            setState({
                ...parent,
                form: {
                    ...state.form,
                    ...Object.fromEntries(
                        initialFields.map((field, index) => [
                            field,
                            { ...state.form[field], state: "form", position: index }
                        ])
                    )
                }
            })
        } else {
            setState({
                ...parent,
                form: {
                    ...state.form,
                    ...parent.form
                }
            })
        }
    }, [])

    useEffect(() => {
        //add debounce
        setParent(state) // Initialize from bd if id
        return () => {
            setParent(state)
        }
    }, [state])

    const handleDragStart = (e, item, source, index = null) => {
        e.dataTransfer.setData("text/plain", item);
        setDragSource(source);
        setDragItem(item);
        setDroppedInsideForm(false);
        setPlaceholderIndex(null);
    }

    const handleDragOverForm = (e) => {
        e.preventDefault();
        setIsDraggingOverForm(true);

        if (dragSource !== "form" && dragSource !== "selection") return;

        const mouseY = e.clientY;

        if (formItems.length === 0) {
            setPlaceholderIndex(0);
            return;
        }

        let newIndex = formItems.length;

        for (let i = 0; i < formItems.length; i++) {
            const el = shadowRoot.getElementById(`form-item-${i}`);
            if (!el) continue;

            const rect = el.getBoundingClientRect();
            const middleY = rect.top + rect.height / 2;

            if (mouseY < middleY) {
                newIndex = i;
                break;
            }
        }

        setPlaceholderIndex(newIndex);
    }

    const handleDragLeaveForm = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const { clientX: x, clientY: y } = e;

        const isOutside =
            x < rect.left ||
            x > rect.right ||
            y < rect.top ||
            y > rect.bottom;

        if (isOutside) {
            setIsDraggingOverForm(false);
        }
    }

    const handleDragEnd = () => {
        if (dragSource === "form" && !droppedInsideForm && dragItem) {
            state.form[dragItem].state = 'selection'
            state.form[dragItem].position = 0
            setState({ ...state.form })
        }
        setDragSource(null);
        setDragItem(null);
        setPlaceholderIndex(null);
    }

    function insertAtPosition(form, draggedKey, newPosition) {
        const draggedItem = form[draggedKey];

        // posição antiga
        const oldPosition = draggedItem.position;

        // se a posição não mudou, não faz nada
        if (oldPosition === newPosition && draggedItem.state === 'form') return form;

        // cria uma cópia
        const updated = structuredClone(form);

        // 1. remove temporariamente o item arrastado
        delete updated[draggedKey];

        // 2. empurra todos os itens que estão na posição >= newPosition
        Object.entries(updated).forEach(([key, item]) => {
            if (item.state === "form" && item.position >= newPosition) {
                item.position += 1;
            }
        });

        // 3. recoloca o item arrastado na posição desejada
        updated[draggedKey] = {
            ...draggedItem,
            position: newPosition,
            state: "form"
        };

        //Reordena tudo
        Object.values(updated).filter(item => item.state === 'form')
            .toSorted((a, b) => a.position - b.position)
            .map((item, index) => item.position = index)

        return updated;
    }

    const handleDropForm = (e) => {
        e.preventDefault();
        setDroppedInsideForm(true);

        const newForm = insertAtPosition(state.form, dragItem, placeholderIndex);

        setState({ form: newForm });

        setPlaceholderIndex(null);
    };

    return (
        <Box display="flex" gap="1rem" height="100%" overflow='hidden' sx={{ flex: '1 1 auto', minHeight: 0 }}>
            {/* Área do formulário */}
            <Box display="flex" flexDirection="column" gap=".5rem" flex={7} maxWidth='70%' minHeight='0px' overflow='hidden' position='relative'>
                <FieldObject state='selection' title={'Estilo do formulário'} type='general' parent={parent} props={parent?.settings?.general || {}}
                    setProps={(newprops) => {
                        parent.settings.general = newprops
                        setParent({ ...parent })
                    }}
                />
                <Box flex={1} minHeight='0px' overflow='auto'>
                    <Shadow onShadowRoot={setShadowRoot} stylesheet='/kwik-form.css'>
                        <body style={{ padding: '.75rem 0rem' }}>
                            <form className='kwik-form' style={{...(parent?.settings?.general || {}), maxWidth: '450px'}}>
                                <div
                                    onDragOver={handleDragOverForm}
                                    onDragLeave={handleDragLeaveForm}
                                    onDrop={handleDropForm}
                                >
                                    <div id="kwik-form-body" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                                        {(formItems.length === 0 && placeholderIndex === null) && "Arraste itens para cá"}
                                        {formItems.map((item, index) => (
                                            <>
                                                {placeholderIndex === index && (
                                                    <div style={{
                                                        height: "40px",
                                                        background: isDraggingOverForm ? "#90caf9" : "#ef5350",
                                                        borderRadius: "4px",
                                                        marginBottom: ".5rem",
                                                        overflow: 'auto'
                                                    }} />
                                                )}

                                                <div
                                                    id={`form-item-${index}`}
                                                    draggable
                                                    onDragStart={(e) => handleDragStart(e, item.id, "form", index)}
                                                    onDragEnd={handleDragEnd}
                                                    style={{
                                                        cursor: "grab",
                                                        userSelect: "none",
                                                    }}
                                                >
                                                    <FieldObject {...item} setProps={(newprops) => {
                                                        state.form[item.id].props = newprops
                                                        setState({ form: { ...state.form } })
                                                    }} parent={parent} />
                                                </div>
                                            </>
                                        ))}

                                        {placeholderIndex === formItems.length && (
                                            <div style={{
                                                height: "40px",
                                                background: isDraggingOverForm ? "#90caf9" : "#ef5350",
                                                borderRadius: "4px",
                                                marginTop: ".5rem"
                                            }} />
                                        )}
                                        <FieldObject state='form' title='Enviar' type='button' parent={parent} props={parent?.settings?.button || {}}
                                            setProps={(newprops) => {
                                                parent.settings.button = newprops
                                                setParent({ ...parent })
                                            }}
                                        />
                                    </div>
                                </div>
                            </form>
                        </body>
                        <script src="https://unpkg.com/imask"></script>
                    </Shadow>
                </Box>
            </Box>

            {/* Área de seleção */}
            <Box flex={3} minWidth="0px" maxWidth='30%' minHeight='0px' overflow='hidden'>
                <Box padding='.5rem' display='flex' flexDirection='column' gap='.5rem' height='100%' overflow='auto'>
                    {Object.entries(categories).map(([field, data]) => (
                        <>
                            <strong>{data.name}</strong>
                            {selectionItems.flatMap((item) => {
                                if (item.category !== field) return []
                                return (<Paper
                                    key={item.id}
                                    draggable
                                    onDragStart={(e) => handleDragStart(e, item.id, "selection")}
                                    onDragEnd={handleDragEnd}
                                    sx={{
                                        padding: ".5rem",
                                        cursor: "grab",
                                        userSelect: "none",
                                    }}
                                >
                                    {item.title}
                                </Paper>)
                            })}
                        </>
                    ))}
                </Box>
            </Box>
        </Box>
    )
}

export default WebFormsStep2
